if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && Shopify.designMode) return;
        this.media = this.querySelector('.dj-popup__media');
        this.eyebrow = this.querySelector('[data-popup-eyebrow]');
        this.title = this.querySelector('[data-popup-title]');
        this.copy = this.querySelector('[data-popup-copy]');
        this.button = this.querySelector('[data-popup-button]');
        this.state = 'first';
        this.secondTimer = null;

        const snoozedUntil = Number(localStorage.getItem('djNewsletterPopupSnoozedUntil') || 0);
        if (snoozedUntil && Date.now() < snoozedUntil) return;

        this.querySelectorAll('[data-popup-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.querySelector('form')?.addEventListener('submit', () => this.snooze());

        if (sessionStorage.getItem('djNewsletterPopupFirstClosed') === 'true') {
          this.scheduleSecond();
          return;
        }

        window.setTimeout(() => {
          this.show('first');
        }, 600);
      }

      show(state) {
        this.state = state;
        this.applyState(state);
        this.hidden = false;
        document.body.classList.add('dj-popup-open');
      }

      applyState(state) {
        const prefix = state === 'second' ? 'second' : 'first';

        this.eyebrow.textContent = this.dataset[`${prefix}Eyebrow`] || '';
        this.title.textContent = this.dataset[`${prefix}Title`] || '';
        this.copy.textContent = this.dataset[`${prefix}Copy`] || '';
        this.button.textContent = this.dataset[`${prefix}Button`] || this.button.textContent;
        this.media.style.setProperty('--dj-popup-image', `url("${this.dataset[`${prefix}Image`]}")`);

        this.classList.toggle('dj-popup--second', state === 'second');
      }

      close() {
        this.hidden = true;
        document.body.classList.remove('dj-popup-open');

        if (this.state === 'first' && sessionStorage.getItem('djNewsletterPopupSecondShown') !== 'true') {
          sessionStorage.setItem('djNewsletterPopupFirstClosed', 'true');
          this.scheduleSecond();
          return;
        }

        this.snooze();
      }

      scheduleSecond() {
        if (sessionStorage.getItem('djNewsletterPopupSecondShown') === 'true') return;

        window.clearTimeout(this.secondTimer);
        this.secondTimer = window.setTimeout(() => {
          sessionStorage.setItem('djNewsletterPopupSecondShown', 'true');
          this.show('second');
        }, 90000);
      }

      snooze() {
        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        localStorage.setItem('djNewsletterPopupSnoozedUntil', String(Date.now() + sevenDays));
      }
    }
  );
}
